// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__17PbN","rootSmall":"AddTileButton_rootSmall__2y1tq"};